export class DomainError extends Error {
    code;
    details;
    constructor(code, message, details) {
        super(message);
        this.name = "DomainError";
        this.code = code;
        this.details = details;
    }
}
export class VersionConflictError extends DomainError {
    constructor(entityId, expectedVersion, actualVersion) {
        super("VERSION_CONFLICT", "This record changed after it was opened.", {
            entityId,
            expectedVersion,
            actualVersion
        });
        this.name = "VersionConflictError";
    }
}
//# sourceMappingURL=errors.js.map